import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { create, update } from "../../services/upload-files.service";
import { useDispatch } from "react-redux";
import { addDepartment, start, updateDepartment } from "../../store/slices/TeamManagementSlice";

const AddDepartment = ({ selectedRow, setShowOffcanvas, showOffcanvas, setSelectedRow, operation }) => {
    const [formData, setFormData] = useState();
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setSelectedRow((prevSelectedRow) => ({
            ...prevSelectedRow,
            [name]: value
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: ""
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (selectedRow.department_name.trim() === "") {
            newErrors.department_name = "Please Enter Department Name";
        }

        if (selectedRow.description.trim() === "") {
            newErrors.description = "Please Enter Department Description";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            setFormData(operation === "update" ? {
                department_name: selectedRow.department_name,
                description: selectedRow.description,
                type: selectedRow.type,
                id: selectedRow.id,
            } : {
                department_name: selectedRow.department_name,
                description: selectedRow.description,
                type: selectedRow.type,
            });

            setShowOffcanvas(false);
        }
    };

    useEffect(() => {
        if (formData) {
            dispatch(start());
            if (operation === 'create') {
                create(formData, 'departments').then((res) => {
                    dispatch(addDepartment(res));
                });
            } else {
                update(formData, 'departments').then((res) => {
                    dispatch(updateDepartment(res));
                });
            }
        }
    }, [formData, dispatch]);

    const resetForm = () => {
        setSelectedRow({
            ...selectedRow,
            department_name: '',
            description: ''
        });
        setErrors({});
    };

    const handleClose = () => {
        resetForm();
        setShowOffcanvas(false);
    };

    return (
        <>
            <Offcanvas
                show={showOffcanvas}
                onHide={handleClose}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Department</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={handleSubmit} onReset={resetForm}>
                        <div className="mb-3">
                            <label htmlFor="department_name" className="form-label">
                                Department Name:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="department_name"
                                name="department_name"
                                aria-describedby="nameHelp"
                                value={selectedRow.department_name}
                                onChange={handleInputChange}
                            />
                            {errors.department_name && <span>{errors.department_name}</span>}
                        </div>
                        <div className="mb-3">
                            <label htmlFor="description" className="form-label">
                                Department Description:
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="description"
                                name="description"
                                aria-describedby="descriptionlHelp"
                                value={selectedRow.description}
                                onChange={handleInputChange}
                            />
                            {errors.description && <span>{errors.description}</span>}
                        </div>
                        <fieldset disabled>
                            <div className="mb-3">
                                <label htmlFor="status" className="form-label">
                                    Department Status:
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="status"
                                    name="status"
                                    aria-describedby="statusHelp"
                                    value={selectedRow.status ? "Active" : "Inactive"}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </fieldset>
                        <button type="submit" className="btn btn-primary btn-add">
                            {operation === "create" ? "Add" : "Update"}
                        </button>
                        <button type="reset" className="btn btn-primary btn-add">
                            Reset
                        </button>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddDepartment;